import { render, staticRenderFns } from "./TopPng.vue?vue&type=template&id=4fc58483&scoped=true&"
import script from "./TopPng.vue?vue&type=script&lang=js&"
export * from "./TopPng.vue?vue&type=script&lang=js&"
import style0 from "./TopPng.vue?vue&type=style&index=0&id=4fc58483&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc58483",
  null
  
)

export default component.exports